import React from "react";
import ReactDOM from "react-dom";
import "site.scss";
import Root from "./BlogsRoot";

ReactDOM.render(<Root />, document.getElementById("app"));

if (DEVELOPMENT) {
    module.hot.accept("BlogsRoot", (e) => {
        const Root = require("BlogsRoot").default;
        ReactDOM.render(<Root />, document.getElementById("app"));
    });
    __webpack_public_path__ = DEVELOPMENT_SERVER_STATIC_PATH;
}
